import React from 'react';
import { SVGAttributes } from 'react';

export const MedicalVerificationColouredIcon: React.FC<SVGAttributes<never>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="verified">
        <g id="Group">
          <path
            id="Vector"
            d="M7.40884 49.1068C7.40884 36.8099 1.03906 28.3654 1.03906 22.4401C1.03906 16.5148 4.44529 4.07031 31.704 4.07031C58.9626 4.07031 62.9626 20.8116 62.9626 27.329C62.9644 57.8481 7.40884 70.8845 7.40884 49.1068Z"
            fill="#EFEFEF"
          />
        </g>
        <g id="Group_2">
          <g id="Group_3">
            <path
              id="Vector_2"
              d="M47.8242 11.7637L49.0813 10.5066L51.5955 13.0208L50.3384 14.2778L47.8242 11.7637Z"
              fill="#FF7575"
            />
          </g>
          <g id="Group_4">
            <path
              id="Vector_3"
              d="M55.0547 18.9902L56.3118 17.7332L58.8259 20.2473L57.5688 21.5044L55.0547 18.9902Z"
              fill="#FF7575"
            />
          </g>
          <g id="Group_5">
            <path
              id="Vector_4"
              d="M54.7383 13.0176L57.2524 10.5034L58.5095 11.7605L55.9954 14.2747L54.7383 13.0176Z"
              fill="#FF7575"
            />
          </g>
        </g>
        <g id="Group_6">
          <path
            id="Vector_5"
            d="M36.048 46.6667H15.5556C13.6 46.6667 12 45.0667 12 43.1111V15.5556C12 13.6 13.6 12 15.5556 12H36C37.9556 12 39.5556 13.6 39.5556 15.5556L39.6036 43.1058C39.6053 45.0702 38.0124 46.6667 36.048 46.6667Z"
            fill="#F3F3F1"
          />
          <g id="Group 28">
            <rect
              id="Rectangle 30514"
              x="22.6445"
              y="17.6973"
              width="4.98579"
              height="10.983"
              fill="#FE646F"
            />
            <rect
              id="Rectangle 30515"
              x="30.6289"
              y="20.6914"
              width="4.98579"
              height="10.983"
              transform="rotate(90 30.6289 20.6914)"
              fill="#FE646F"
            />
            <path
              id="Vector_6"
              d="M19.1179 27.0653H21.5491V29.4964C21.5491 29.8188 21.6772 30.128 21.9051 30.356C22.1331 30.5839 22.4423 30.712 22.7647 30.712H27.627C27.9494 30.712 28.2586 30.5839 28.4866 30.356C28.7145 30.128 28.8426 29.8188 28.8426 29.4964V27.0653H31.2738C31.5962 27.0653 31.9054 26.9372 32.1333 26.7092C32.3613 26.4813 32.4894 26.1721 32.4894 25.8497V20.9873C32.4894 20.6649 32.3613 20.3558 32.1333 20.1278C31.9054 19.8998 31.5962 19.7718 31.2738 19.7718H28.8426V17.3406C28.8426 17.0182 28.7145 16.709 28.4866 16.481C28.2586 16.2531 27.9494 16.125 27.627 16.125H22.7647C22.4423 16.125 22.1331 16.2531 21.9051 16.481C21.6772 16.709 21.5491 17.0182 21.5491 17.3406V19.7718H19.1179C18.7955 19.7718 18.4863 19.8998 18.2584 20.1278C18.0304 20.3558 17.9023 20.6649 17.9023 20.9873V25.8497C17.9023 26.1721 18.0304 26.4813 18.2584 26.7092C18.4863 26.9372 18.7955 27.0653 19.1179 27.0653ZM20.3335 22.2029H22.7647C23.0871 22.2029 23.3963 22.0749 23.6242 21.8469C23.8522 21.6189 23.9803 21.3097 23.9803 20.9873V18.5562H26.4114V20.9873C26.4114 21.3097 26.5395 21.6189 26.7675 21.8469C26.9954 22.0749 27.3046 22.2029 27.627 22.2029H30.0582V24.6341H27.627C27.3046 24.6341 26.9954 24.7622 26.7675 24.9901C26.5395 25.2181 26.4114 25.5273 26.4114 25.8497V28.2808H23.9803V25.8497C23.9803 25.5273 23.8522 25.2181 23.6242 24.9901C23.3963 24.7622 23.0871 24.6341 22.7647 24.6341H20.3335V22.2029Z"
              fill="black"
            />
          </g>
        </g>
        <g id="Group_7">
          <path
            id="Vector_7"
            d="M16 43.1111V15.5556C16 13.6 17.6 12 19.5556 12H15.5556C13.6 12 12 13.6 12 15.5556V43.1111C12 45.0667 13.6 46.6667 15.5556 46.6667H19.5556C17.6 46.6667 16 45.0667 16 43.1111Z"
            fill="#D5DBE1"
          />
        </g>
        <g id="Group_8">
          <path
            id="Vector_8"
            d="M35.5586 41.7789C35.5586 36.8189 39.0928 32.6855 43.7808 31.7558C43.1337 31.6278 42.4653 31.5566 41.7808 31.5566C36.1346 31.5566 31.5586 36.1326 31.5586 41.7789C31.5586 47.4251 36.1346 52.0011 41.7808 52.0011C42.4653 52.0011 43.1337 51.9318 43.7808 51.802C39.0928 50.8722 35.5586 46.7389 35.5586 41.7789Z"
            fill="#D5DBE1"
          />
        </g>
        <g id="Group_9">
          <path
            id="Vector_9"
            d="M17.7773 34.666H28.444V37.3327H17.7773V34.666Z"
            fill="black"
          />
        </g>
        <g id="Group_10">
          <path
            id="Vector_10"
            d="M17.7773 40H26.6662V42.6667H17.7773V40Z"
            fill="black"
          />
        </g>
        <g id="Group_11">
          <path
            id="Vector_11"
            d="M26.668 47.9993H15.5569C12.86 47.9993 10.668 45.8073 10.668 43.1105V15.5549C10.668 12.858 12.86 10.666 15.5569 10.666H36.0013C38.6982 10.666 40.8902 12.858 40.8902 15.5549V26.7727H38.2235V15.5549C38.2235 14.33 37.2262 13.3327 36.0013 13.3327H15.5569C14.332 13.3327 13.3346 14.33 13.3346 15.5549V43.1105C13.3346 44.3353 14.332 45.3327 15.5569 45.3327H26.668V47.9993Z"
            fill="black"
          />
        </g>
        <g id="Group_12">
          <path
            id="Vector_12"
            d="M41.7782 53.3318C35.4067 53.3318 30.2227 48.1478 30.2227 41.7763C30.2227 35.4047 35.4067 30.2207 41.7782 30.2207C48.1498 30.2207 53.3338 35.4047 53.3338 41.7763C53.3338 48.1478 48.1498 53.3318 41.7782 53.3318ZM41.7782 32.8874C36.8769 32.8874 32.8893 36.8749 32.8893 41.7763C32.8893 46.6776 36.8769 50.6651 41.7782 50.6651C46.6795 50.6651 50.6671 46.6776 50.6671 41.7763C50.6671 36.8749 46.6795 32.8874 41.7782 32.8874Z"
            fill="black"
          />
        </g>
        <g id="Group_13">
          <path
            id="Vector_13"
            d="M44.5078 37.6816H41.0947C40.5516 37.6816 40.0307 37.8974 39.6467 38.2814C39.2626 38.6655 39.0469 39.1863 39.0469 39.7295C39.0469 40.2726 39.2626 40.7934 39.6467 41.1775C40.0307 41.5615 40.5516 41.7773 41.0947 41.7773H42.4599C43.003 41.7773 43.5239 41.993 43.908 42.3771C44.292 42.7611 44.5078 43.282 44.5078 43.8251C44.5078 44.3682 44.292 44.8891 43.908 45.2732C43.5239 45.6572 43.003 45.8729 42.4599 45.8729H39.0469M41.7773 45.8729V47.2382M41.7773 36.3164V37.6816"
            stroke="black"
            strokeWidth="2.06452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default MedicalVerificationColouredIcon;
